module.exports = __webpack_public_path__ + "img/the_invisible_boat_mobile.03acbdfe.jpg";